import React from "react";
import PropTypes from "prop-types";
import CloudUploadIcon from 'mdi-react/CloudUploadIcon';

const Placeholder = ({ getInputProps, getRootProps, error, touched }) => (
  <div
    {...getRootProps()}
    className={`placeholder-preview text-center ${error && touched ? "has-error" : ""}`}
  >
    <input {...getInputProps()} />
    <CloudUploadIcon size={200} />
    <p>Click or drag image file to this area to upload.</p>
  </div>
);

Placeholder.propTypes = {
  error: PropTypes.string,
  getInputProps: PropTypes.func.isRequired,
  getRootProps: PropTypes.func.isRequired,
  touched: PropTypes.bool
};

export default Placeholder;
